import { render, staticRenderFns } from "./AccommodationIndex.vue?vue&type=template&id=913a9e94"
import script from "./AccommodationIndex.vue?vue&type=script&lang=js"
export * from "./AccommodationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports